<template>
<div>    
    <div class="col-12 lg-12 px-0">
      <Toolbar class="p-mb-2">
        <template #start>
          <Dropdown
            v-model="selectedUnidadFiltro"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :showClear="true"
            :filter="true"
            @change="cargaEstatusPorSegmento"
          />
        </template>        
        <template #end>
          <download-excel 
            v-show="selectedUnidadFiltro"
            class="btn p-mr-2"
            :data="lstExport"
            :fields="fieldsExport"
            :stringifyLongNum="true"
            :name="selectedUnidadFiltro?selectedUnidadFiltro.UNIDAD + '.xls':''"
            >
              <Button label="Exportar"
              icon="pi pi-external-link"
              class="p-button-warning p-mr-2" />       
          </download-excel>
        </template>
      </Toolbar>
    </div>

    <!-- <DataTable
      v-if="selectedUnidadFiltro != null"
      :value="lstEquipos"
      :expandedRows.sync="expandedRows"
      dataKey="IP"
      ref="dt"
      :filters="filters"
      :loading.sync="loading"
      :paginator="false"    
      class="p-datatable-sm"      
      :rowClass="rowClass"
    >
      <template #header>
        <div class="table-header-container">
            <Button icon="pi pi-plus" label="Expandir todos" @click="expandAll" class="p-mr-2" />
            <Button icon="pi pi-minus" label="Colapsar todos" @click="collapseAll" />
        </div>
        <div class="table-header">
          <h5>Equipos</h5>
          <span
            >Número de equipos {{ lstEquipos ? lstEquipos.length : 0 }}</span
          >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="text" v-model="filter"  placeholder="Buscar..." @input="buscarEnJson" />
          </span>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>      
      <Column style="padding:0px;" :expander="true" headerStyle="width: 3rem" >
      </Column>
      <Column field="IP" header="IP" headerStyle="width: 75px" >
        <template #body="slotProps">
          <div style="font-size:12px; padding:0px;">{{slotProps.data.IP}}</div> 
        </template>
      </Column>      
      <Column field="TIPO" header="TIPO" headerStyle="width: 100px" sortable>
        <template #body="slotProps">
            <div v-if="slotProps.data.TIPO == 'LIBRE'" >
                <span class="status-LIBRE" style="font-size:12px">LIBRE</span> 
                <Button class="p-button-text p-button-sm " label="PING" @click="pingEquipo(slotProps.data.IP)" icon="pi pi-reply"/>
            </div>
            <span style="font-size:12px" v-else >{{slotProps.data.TIPO}}</span>
        </template>
      </Column>
      <Column field="USERID" header="USUARIO" headerStyle="width: 105px">
        <template #body="slotProps">
          <span style="font-size:12px">{{slotProps.data.USERID}}</span> 
        </template>
      </Column>
      <Column field="NOMBRE" header="NOMBRE EQUIPO" headerStyle="width: 200px">
        <template #body="slotProps">
          <span style="font-size:12px">{{slotProps.data.NOMBRE}}</span> 
        </template>
      </Column>
      <Column field="DATE" header="ULTIMA SINC." headerStyle="width: 90px">
        <template #body="slotProps">
            <span style="font-size:12px">{{getFechaWCF(slotProps.data.DATE,true)}}</span>
        </template>
      </Column>                  
      <template #expansion="slotProps">
        <Card>
          <template slot="content">
            <div class="grid">
              <div class="col-6">
                <div class="grid">
                  <div class="col title">S.O.</div>
                  <div class="col data">
                    {{ slotProps.data.OSNAME }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">Num. serie</div>
                  <div class="col data">
                    {{ slotProps.data.SSN }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MAC</div>
                  <div class="col data">
                    {{ slotProps.data.MAC }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MODELO</div>
                  <div class="col data">
                    {{ slotProps.data.SMODEL }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MARCA</div>
                  <div class="col data">
                    {{ slotProps.data.BMANUFACTURER }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="grid">
                  <div class="col title">PROCESADOR</div>
                  <div class="col data">
                    {{ slotProps.data.PROCESSORT }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">TIPO</div>
                  <div class="col data">
                    {{ slotProps.data.TYPE }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MEMORIA</div>
                  <div class="col data">
                    {{
                      slotProps.data.MEMORY 
                    }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">LUGAR</div>
                  <div class="col data">
                    {{ slotProps.data.DESCRIPTION }}
                  </div>
                </div>                
              </div>              
            </div>
          </template>
        </Card>
      </template>
      <template #footer>
        Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
      </template>
    </DataTable> -->
<div class="table-responsive-estatus">
  <b><small v-if="lstEquipos">Total de equipos: Ocupados: {{(lstEquipos.filter(x => x.TIPO != 'LIBRE')).length}}</small> - <small v-if="lstEquipos">Libres: {{(lstEquipos.filter(x => x.TIPO == 'LIBRE')).length}}</small></b>  
  <hr/>
    <table class="table">
      <thead>
        <tr>          
          <th style="font-size:12px;padding:0px">IP</th>          
          <th style="font-size:12px;padding:0px">TIPO</th>
          <th style="font-size:12px;padding:0px">PING</th>
          <th style="font-size:12px;padding:0px">USUARIO</th>
          <th style="font-size:12px;padding:0px">NOMBRE EQUIPO</th>
          <th style="font-size:12px;padding:0px">MARCA</th>
          <th style="font-size:12px;padding:0px">MODELO</th>
          <th style="font-size:12px;padding:0px">SERIE</th>
          <th style="font-size:12px;padding:0px">MAC</th>
          <th style="font-size:12px;padding:0px">S.O.</th>
          <th style="font-size:12px;padding:0px">AREA</th>
          <th style="font-size:12px;padding:0px">OBSERVACION</th>
          <th style="font-size:12px;padding:0px">ULTIMA SINC.</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in lstEquipos" :key="item.IP" :style="item.TIPO == 'LIBRE'?'background:rgb(192, 248, 192);':''">          
          <td style="font-size:10px;padding:0px">{{item.IP}}</td>
          <td style="font-size:10px;padding:0px">{{item.TIPO}}</td>
          <td style="font-size:10px;padding:0px"><i v-show="muestra(item.IP)" class="pi pi-spin pi-spinner" style="fontSize: 1rem"></i><a v-show="!muestra(item.IP)" style="color:blue;cursor: pointer;"  @click="pingEquipo(item.IP)" icon="pi pi-reply">PING</a></td>
          <td style="font-size:10px;padding:0px">{{item.USERID}}</td>
          <td style="font-size:10px;padding:0px">{{item.NOMBRE}}</td>
          <td style="font-size:10px;padding:0px">{{item.SMANUFACTURER}}</td>
          <td style="font-size:10px;padding:0px">{{item.SMODEL}}</td>
          <td style="font-size:10px;padding:0px">{{item.SSN}}</td>
          <td style="font-size:10px;padding:0px">{{item.MAC}}</td>
          <td style="font-size:10px;padding:0px">{{item.OSNAME}}</td>
          <td style="font-size:10px;padding:0px">{{item.EquipoComputo?.Area}}</td>
          <td style="font-size:10px;padding:0px">{{item.EquipoComputo?.Observaciones}}</td>
          <td style="font-size:10px;padding:0px">{{getFechaWCF(item.DATE,true)}}</td>
        </tr>
      </tbody>      
    </table>
    <b><small v-if="lstEquipos">Total de equipos ocupados: {{(lstEquipos.filter(x => x.TIPO != 'LIBRE')).length}}</small> - <small v-if="lstEquipos">Total de equipos libres: {{(lstEquipos.filter(x => x.TIPO == 'LIBRE')).length}}</small></b>
</div>

</div>
    
</template>

<script>
import Srvr from "../service/Inventario";

export default {
    data(){
        return{
            lstUnidades: [],
            selectedUnidadFiltro: null,
            lstEquipos: null,  
            lstEquiposO: null,
            filters: {},
            filter:null,
            loading: true,
            expandedRows: [],
            vshowIps: [],
            fieldsExport: {
              IP : "IP",
              TIPO : "TIPO",
              USUARIO : "USERID",
              NOMBRE : "NOMBRE",
              MARCA : "SMANUFACTURER",
              MODELO : "SMODEL",
              SERIE : "SSN",
              MAC : "MAC",
              SO : "OSNAME",
              AREA : "EquipoComputo.Area",
              OBSERVACION : "EquipoComputo.Observaciones",
              "ULTIMA ACTUALIZACION" : "ULTIMA_ACTUALIZACION"           
            },
            lstExport: [],
        }
    },
    mounted() {
        var t = this;
        t.cargaInicial();
    },
    // computed: {
    //     lstEquiposExport : function(){
    //       // let obj = {IP : '',TIPO: '',USERID:'',NOMBRE:'',ULTIMA_ACTUALIZACION:''};
    //       return this.lstUnidades;
    //     }
    // },
    methods:{
        // lstEquiposExport(){
        //   return this.lstUnidades;
        // },
        muestra(ip){                    
          var i = this.vshowIps.findIndex(item=>item == ip);          
          return i>=0;
        },
        cargaInicial() {
            var t = this;

            var ctlSvr = new Srvr();
            ctlSvr.getUnidades(t).then((res) => {                
                t.lstUnidades = res;
            });            
        },
        formatoExcel(){
          var t= this;
          t.lstExport.forEach(x => {
            x.ULTIMA_ACTUALIZACION = t.getFechaWCF(x.DATE);
          });
          t.lstExport.push({IP:"Total de equipos ocupados:", TIPO:(t.lstExport.filter(x => x.TIPO != 'LIBRE')).length, USERID : "Total de equipos libres:",NOMBRE:(t.lstExport.filter(x => x.TIPO == 'LIBRE')).length, ULTIMA_ACTUALIZACION:""});
        },
        cargaEstatusPorSegmento(){
            var t = this;
            var ctlSvr = new Srvr();
            
            t.loading = true;
            t.lstEquipos = [];      
            if (t.selectedUnidadFiltro) {
                
                ctlSvr.getEstatusSubnet(t, t.selectedUnidadFiltro.SUBRED).then((res) => {                       
                    //console.log(res);
                    t.loading = false;       
                    t.lstEquipos = res;                    
                    //t.lstEquiposO = res;
                    t.lstExport = [...res];
                    this.formatoExcel();
                });
                
            }
        },
        pingEquipo(host){
            var t = this;
            var ctlSvr = new Srvr();
            
            t.loading = true;

            t.vshowIps.push(host);            

            ctlSvr.PingEquipo(t, host).then((res) => {                       
                t.loading = false;
                t.vshowIps.splice(t.vshowIps.findIndex(item=>item.IP == host));
                if(!res){
                    t.$toast.add({
                        severity: "success",
                        summary: "AVISO",
                        detail: "IP " + host + " libre, no responde a PING",
                        life: 6000,
                    });            
                }
                else{
                    t.$toast.add({
                        severity: "warn",
                        summary: "AVISO",
                        detail: "IP " + host + " en uso, responde a PING",
                        life: 6000,
                    });
                }
            });            
        },
        expandAll(){
            this.expandedRows = this.lstEquipos.filter(e=>e.IP);
        },
        collapseAll(){
            this.expandedRows = null;
        },
        getFechaWCF(fecha,hora){
            if(fecha){
                var millis = fecha
                .replace("/Date(","")
                .replace("/","")
                .replace(")","");           
                
                millis = millis * 1;

                if(millis>0){  
                var mfecha = new Date(millis);
            
                var res = mfecha.getDate() < 10 ? "0" + mfecha.getDate(): mfecha.getDate();
                res+="/";
                res+=(mfecha.getMonth() + 1) < 10 ? "0" + (mfecha.getMonth() + 1):(mfecha.getMonth() + 1);
                res+="/";
                res+=mfecha.getFullYear();

                if(hora){
                    res+=" ";
                    res+=(mfecha.getHours());
                    res+=":"
                    res+=mfecha.getMinutes() < 10 ? "0" + mfecha.getMinutes(): mfecha.getMinutes();
                }

                return res;
                }
                else{        
                return "N/D";
                }
            }
        },
        buscarEnJson(e){      
            var t = this;
            var nArray = [];
            t.lstEquipos = [];
            if(e && e != ""){                
                for(let i in t.lstEquiposO){
                var obj = t.lstEquiposO[i];
                Object.getOwnPropertyNames(obj).forEach(function(val) {          
                    if(obj[val] && obj[val].toString().toLowerCase().indexOf(e.toLowerCase()) ==! -1){       
                    if(!nArray.find(p=>p.Id_equipo == obj.Id_equipo))                     
                        nArray.push(obj);
                    }              
                }); 
                }        
                t.lstEquipos = nArray.slice();
            }
            else{
                t.lstEquipos = t.lstEquiposO;
            }
        },        
    }
}
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
  background: rgb(192, 248, 192);
  cursor: pointer;
}
.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}
.product-image {
  width: 100px;  
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
}
</style>
